<template>
<div class="column">
  <div class="columns p-0">
    <div class="column py-0 ">
       <h3 class="is-size-3 has-text-weight-bold line-height">Procore</h3>
    </div>
    <div class="column py-0 is-justify-content-end is-align-items-center">
      <div class="buttons is-pulled-right">
      <button v-if="isEdit && editSubmittal" class="button is-outlined p-0"
                @click="toggleEdit()"
                v-tooltip="'Cancel'"
                v-permission="{permissionModule: 'app&projects', type: 'alterProject',
                project: project}">
          <i class="icon-close"></i>
        </button>
        <button v-if="isEdit && editSubmittal"
                class="button has-background-black-bis has-text-white p-0"
                @click="save" v-tooltip="'Save'">
          <i class="icon-checkmark has-text-white"></i>
        </button>
        <button v-if="!isEdit"
                class="button has-text-black-bis p-0"
                @click="toggleEdit()"
                v-tooltip="'Edit'"
                v-permission="{permissionModule: 'app&projects', type: 'alterProject',
                project: project}">
          <i class="icon-edit"></i  >

        </button>
      </div>
    </div>
  </div>
  <h3 class="is-size-3 has-text-weight-semibold line-height" v-if="!alreadyLinked && !isEdit">Not Linked with any Procore Project.</h3>
  <div class="columns is-multiline px-0"  v-else>
    <div class="column is-full">
        <h3 class="is-size-3 has-text-weight-semibold line-height">Procore Company</h3>
        <mf-multi-select
          :options="companies"
          v-model="selectedCompany"
          :disabled="!isEdit"
          placeholder="Select a Company"
          track-by="id" label="name"
          @select="getProjects"
          :multiple="false"
          :allow-empty="false">
        </mf-multi-select>
    </div>
    <div class="column is-full">
      <h3 class="is-size-3 has-text-weight-semibold line-height">Procore Project</h3>
      <mf-multi-select
          v-model="selectedProject"
          :options="projects"
          :disabled="!isEdit"
          placeholder="Select a Project"
          track-by="id" label="name"
          :multiple="false"
          :allow-empty="false">
        </mf-multi-select>
    </div>
  </div>
</div>
</template>

<script>
import { defineComponent, getCurrentInstance, onMounted, ref, toRefs, reactive, computed } from 'vue';
import { useToast } from "vue-toastification";
import { DialogProgrammatic } from '@/components/Dialog';
import Procore from '@/models/Procore';
import MfMultiSelect from '@/components/abstract/MfMultiSelect.vue';
import _ from 'lodash';

export default defineComponent({
  name: 'Submittal',
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
    saveProject: {
      type: Function,
      default: () => {},
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MfMultiSelect,
  },
  setup(props, { emit }) {
    const toast = useToast();
    const data = reactive({
      isEdit: false,
      companies: [],
      projects: [],
      selectedCompany: '',
      selectedProject: '',
      alreadyLinked: true,
      edit: false,
      editSubmittal: false,
    });

    const initialize = async () => {
      const procoreSetting = _.find(_.get(props.project, 'apis', []), { name: 'procore' });
      data.companies = await Procore.getCompanies();
      if (_.get(procoreSetting, 'name', '') !== '') {
        data.alreadyLinked = true;
        data.edit = false;
        data.selectedCompany = procoreSetting.params.company_id;
        data.selectedProject = procoreSetting.params.project_id;
        data.projects = await Procore.getProjects({ companyId: data.selectedCompany });
      } else {
        data.alreadyLinked = false;
        data.edit = true;
      }
      emit('save-clicked');
    };

    const toggleEdit = () => {
      if (data.alreadyLinked) {
        toast.warning('This project is already linked to a Procore project');
      } else {
        data.isEdit = !data.isEdit;
      }
    };

    const getProjects = async (companyId) => {
      if (companyId) {
        data.projects = await Procore.getProjects({ companyId });
      }
    };

    const save = async () => {
      if (!data.selectedCompany || !data.selectedProject) {
        const confirmParams = {
          title: 'Error',
          message: 'Procore Company and Procore Project is mandatory',
          type: 'danger',
          okButton: 'OK',
          cancelButton: 'Cancel',
        };
        DialogProgrammatic.confirm(confirmParams);
      } else {
        const params = {
          procoreCompanyId: data.selectedCompany,
          procoreProjectId: data.selectedProject,
          projectId: props.project._id,
        };
        const confirmParams = {
          title: 'Are you Sure?',
          message: 'Once you attach a Procore project, it cannot be undone, Continue?',
          confirmText: 'Yes',
          type: 'danger',
          okButton: 'OK',
          cancelButton: 'Cancel',
          onConfirm: async () => {
            try {
              const project = await Procore.linkProject(params);
              props.project.apis = _.cloneDeep(project.apis);
              toast.success('Procore Project linked!');
              data.edit = false;
              data.alreadyLinked = true;
              props.saveProject();
            } catch (error) {
              toast.error(`Error linking Procore project - ${error.data}.  Please contact ManufactOn support`);
            }
          }
        };
        DialogProgrammatic.confirm(confirmParams);
      }
    };

    const checkSubmittal = computed(() => {
      const procoreSetting = _.find(_.get(props.project, 'apis', []), { name: 'procore' });
      return !(_.get(procoreSetting, 'name', '') !== '');
    });

    onMounted(() => {
      data.editSubmittal = checkSubmittal.value;
      initialize();
    });

    return {
      ...toRefs(data),
      toggleEdit,
      getProjects,
      save,
      checkSubmittal,
    };
  }
});
</script>

<style scoped>
 .columns {
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
</style>
